export default {
  'menu-nav': {
    menu: 'Menu',
    'ciders-and-spirits': 'Cidres',
    'high-altitude': 'Haute altitude',
    'savoir-faire': 'Savoir-faire',
    contacts: 'Contactez-nous',
    home: 'Accueil',
    back: 'Retour',
  },
  news: 'Actualités',
}
